import { Icon } from "../../atoms/icons";
import { Typography } from "../../atoms/typography";
import { cn } from "../../lib";
import { Box } from "../../primitives";
import { iconSize } from "../../tokens";
import { listItemIconColor, useListItemContext } from "./list-item-context";
import type {
  ListItemTrailingIconProps,
  ListItemTrailingProps,
  ListItemTrailingTextProps,
} from "./types";

export const ListItemTrailing = ({ className, children }: ListItemTrailingProps) => (
  <Box className={cn("gap-spacing-sm flex flex-row items-center", className)}>{children}</Box>
);

ListItemTrailing.displayName = "ListItem.Trailing";

// The style comes from `variant`, as the content's text does: as a class,
// Typography's default body-md kept its desktop size beside it
export const ListItemTrailingText = ({ className, children }: ListItemTrailingTextProps) => {
  const { disabled } = useListItemContext();
  return (
    <Typography
      variant="body-sm"
      color={disabled ? "neutral-foreground-attenuated" : "neutral-foreground-intermediate"}
      className={className}
    >
      {children}
    </Typography>
  );
};

ListItemTrailingText.displayName = "ListItem.TrailingText";

// The colour goes to the Icon as a prop: on iOS and Android a wrapper's text
// colour doesn't reach the icon inside it. Figma's trailing icon is 16
export const ListItemTrailingIcon = ({
  name,
  size = iconSize.sm,
  color,
  className,
}: ListItemTrailingIconProps) => {
  const row = useListItemContext();
  return (
    <Box className={cn("flex flex-row items-center justify-center", className)}>
      <Icon name={name} size={size} color={listItemIconColor(row, color)} />
    </Box>
  );
};

ListItemTrailingIcon.displayName = "ListItem.TrailingIcon";
